import React, { PropsWithChildren, SyntheticEvent } from 'react'

import style from './Dropdown.scss'

interface IProps {
  label?: string
  onChange?: (e: SyntheticEvent<HTMLSelectElement>) => void
  className?: string
  value?: string | string[] | number
  reverse?: boolean
  isDisabled?: boolean
  isFullWidth?: boolean
}

const Dropdown = ({
  label,
  children,
  onChange,
  value,
  className,
  reverse = false,
  isDisabled = false,
  isFullWidth = false,
}: PropsWithChildren<IProps>) => {
  return (
    <div
      className={`${className} ${style.dropdown} ${
        reverse ? style.reverse : undefined
      } ${isFullWidth ? style.full : undefined}`}>
      {label ? <label>{label}</label> : null}
      <div className={`${style.select}`}>
        <select onChange={onChange} value={value} disabled={isDisabled}>
          {children}
        </select>
      </div>
    </div>
  )
}

export default Dropdown
